import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useGetBookingWindowDaysByFacilityId$key } from "./__generated__/useGetBookingWindowDaysByFacilityId.graphql";

export const useGetBookingWindowDaysByFacilityId = ({
  fragmentRef,
}: {
  fragmentRef: useGetBookingWindowDaysByFacilityId$key | null;
}) => {
  const data = useFragment(
    useGetBookingWindowDaysByFacilityIdFragment,
    fragmentRef
  );

  const windowDays = data?.club?.supportsPrivate
    ? data?.memberBookingWindowDays ?? 14
    : data?.publicBookingWindowDays ?? 60;

  return windowDays;
};

export const useGetBookingWindowDaysByFacilityIdFragment = graphql`
  fragment useGetBookingWindowDaysByFacilityId on Facility {
    id
    publicBookingWindowDays
    memberBookingWindowDays
    club {
      supportsPrivate
    }
  }
`;
